module.exports = __webpack_public_path__ + "static/media/29ADMSPC16.47c79649.jpg";